var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { pageWindow } from '../../../../domain';
let CompanyRowScope = class CompanyRowScope extends Scope {
    constructor() {
        super(...arguments);
        this.companyId = 0;
        this.cnpj = '-';
        this.razaoSocial = '-';
        this.nomeFantasia = '-';
        this.ramoAtividade = '-';
        this.contactName = '-';
        this.contactEmail = '-';
        this.contactPhone = '-';
        this.active = true;
        this.onEdit = Scope.ASYNC_ACTION;
        this.onViewCollaborators = Scope.ASYNC_ACTION;
        this.onToggleAccess = Scope.ASYNC_ACTION;
        this.onDelete = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "companyId", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "cnpj", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "razaoSocial", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "nomeFantasia", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "ramoAtividade", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "contactName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "contactEmail", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "contactPhone", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyRowScope.prototype, "active", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], CompanyRowScope.prototype, "totalUsers", void 0);
CompanyRowScope = __decorate([
    Observable
], CompanyRowScope);
export { CompanyRowScope };
let CompanyColumnScope = class CompanyColumnScope extends Scope {
    constructor() {
        super(...arguments);
        this.field = 'cnpj';
        this.label = '';
        this.sorted = false;
        this.descending = false;
        /** A coluna se arrasta para outro lugar - todas, menos o CNPJ, que identifica a linha. */
        this.movable = false;
        this.onSort = Scope.ASYNC_ACTION;
        /** Outra coluna, `source`, foi solta sobre esta. */
        this.onDrop = () => undefined;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyColumnScope.prototype, "field", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyColumnScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyColumnScope.prototype, "sorted", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyColumnScope.prototype, "descending", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyColumnScope.prototype, "movable", void 0);
CompanyColumnScope = __decorate([
    Observable
], CompanyColumnScope);
export { CompanyColumnScope };
let StatusOptionScope = class StatusOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], StatusOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusOptionScope.prototype, "current", void 0);
StatusOptionScope = __decorate([
    Observable
], StatusOptionScope);
export { StatusOptionScope };
let StatusFilterScope = class StatusFilterScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = 'STATUS';
        this.summary = '';
        this.active = false;
        this.options = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusFilterScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusFilterScope.prototype, "summary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusFilterScope.prototype, "active", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], StatusFilterScope.prototype, "options", void 0);
StatusFilterScope = __decorate([
    Observable
], StatusFilterScope);
export { StatusFilterScope };
let CompaniesScope = class CompaniesScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        /**
         * Conta as escritas PROGRAMATICAS nos campos de texto.
         *
         * Campo nao controlado ignora mudanca de `defaultValue`, e sem isto o
         * "Limpar" esvaziava o scope sem esvaziar a tela - o mesmo contador de Meus
         * dados, de Colaboradores e dos Monitoramentos.
         */
        this.formRevision = 0;
        /**
         * Os SETE campos de texto do filtro. Espelham o digitado; a busca sai no
         * submit.
         *
         * Ramo de atividade, e-mail e telefone do contato sao ADICAO do porte: a
         * referencia filtra so por CNPJ, razao social, nome fantasia, contato e
         * status.
         */
        this.cnpj = '';
        this.razaoSocial = '';
        this.nomeFantasia = '';
        this.ramoAtividade = '';
        this.contactName = '';
        this.contactEmail = '';
        this.contactPhone = '';
        this.anyFilterActive = false;
        this.columns = [];
        this.rows = [];
        this.page = 1;
        /** Dez, como o `rowsPerPage={10}` da referencia nesta tela. */
        this.perPage = 10;
        this.total = 0;
        this.onCnpjChanged = Scope.SYNC_ACTION_STRING;
        this.onRazaoSocialChanged = Scope.SYNC_ACTION_STRING;
        this.onNomeFantasiaChanged = Scope.SYNC_ACTION_STRING;
        this.onRamoAtividadeChanged = Scope.SYNC_ACTION_STRING;
        this.onContactNameChanged = Scope.SYNC_ACTION_STRING;
        this.onContactEmailChanged = Scope.SYNC_ACTION_STRING;
        this.onContactPhoneChanged = Scope.SYNC_ACTION_STRING;
        this.onSubmit = Scope.ASYNC_ACTION;
        this.onClearFilters = Scope.ASYNC_ACTION;
        this.onNew = Scope.ASYNC_ACTION;
        this.onPreviousPage = Scope.ASYNC_ACTION;
        this.onNextPage = Scope.ASYNC_ACTION;
        this.onGoToPage = Scope.ASYNC_ACTION_NUMBER;
    }
    get pageCount() {
        return Math.max(1, Math.ceil(this.total / Math.max(1, this.perPage)));
    }
    /**
     * As paginas que o paginador oferece - lista pronta, e nao uma regra a aplicar.
     *
     * Deriva de `page` e `pageCount`, os dois ja observados, entao muda junto com
     * eles. Fica aqui e nao na view para que outra renderizacao so LEIA: quem desenha
     * nao precisa saber que a janela tem cinco nem que ela se centra na atual.
     */
    get pageWindow() {
        return pageWindow(this.page, this.pageCount);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Function)
], CompaniesScope.prototype, "layout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompaniesScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "formRevision", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "cnpj", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "razaoSocial", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "nomeFantasia", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "ramoAtividade", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "contactName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "contactEmail", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "contactPhone", void 0);
__decorate([
    observe(),
    __metadata("design:type", StatusFilterScope)
], CompaniesScope.prototype, "statusFilter", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "anyFilterActive", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompaniesScope.prototype, "columns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompaniesScope.prototype, "rows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "page", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "perPage", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompaniesScope.prototype, "total", void 0);
CompaniesScope = __decorate([
    Observable
], CompaniesScope);
export { CompaniesScope };
//# sourceMappingURL=companies.scope.js.map